const PROXY_URL = 'http://localhost:3001';

export interface UdpMessageParams {
  address: string;
  port: number;
  zone: number;
  type: string;
  id: number;
  telemetry: number;
  value: number;
}

export interface ReceivedUdpMessage {
  zone: number;
  type: string;
  id: number;
  telemetry: number;
  value: number;
  raw: string;
  from: string;
  port: number;
  timestamp: number;
}

class UdpService {
  private eventSource: EventSource | null = null;
  private listeners: ((msg: ReceivedUdpMessage) => void)[] = [];
  public isEnabled: boolean = false;

  constructor() {
    // 자동 연결 해제: 기본값을 off로 설정
  }

  public toggle(enabled: boolean) {
    this.isEnabled = enabled;
    if (enabled) {
      this.connect();
    } else {
      this.disconnect();
    }
  }

  public disconnect() {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }
  }

  private connect() {
    if (!this.isEnabled || this.eventSource) return;
    this.eventSource = new EventSource(`${PROXY_URL}/events`);
    this.eventSource.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        this.listeners.forEach(l => l(data));
      } catch (err) {
        console.error('Failed to parse SSE data', err);
      }
    };
    this.eventSource.onerror = (err) => {
      console.error('SSE connection lost, retrying...', err);
      this.eventSource?.close();
      this.eventSource = null;
      if (this.isEnabled) {
        setTimeout(() => this.connect(), 5000);
      }
    };
  }

  async send(params: UdpMessageParams) {
    const response = await fetch(`${PROXY_URL}/send`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params)
    });
    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.error || 'Failed to send UDP');
    }
    return response.json();
  }

  subscribe(callback: (msg: ReceivedUdpMessage) => void) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter(l => l !== callback);
    };
  }
}

export const udpService = new UdpService();
